import { IHTTPCompletedResponse } from '@cian/http-api/shared';

export function filterServerResponse(response: IHTTPCompletedResponse) {
  if (response.responseStatusCode === 400) {
    throw response;
  }

  return response;
}
